/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_OverlineInputs */

const en_mk_hero_overline = /** @type {(inputs: Mk_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAN · BUILD · REVIEW · PUBLISH`)
};

const id_mk_hero_overline = /** @type {(inputs: Mk_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RENCANAKAN · BANGUN · TINJAU · TERBITKAN`)
};

/**
* | output |
* | --- |
* | "PLAN · BUILD · REVIEW · PUBLISH" |
*
* @param {Mk_Hero_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_overline = /** @type {((inputs?: Mk_Hero_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_overline(inputs)
	return en_mk_hero_overline(inputs)
});